import styled from 'styled-components'
import { theme } from '@superhi/design'

export const VideoWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${theme.colors.GREY_10};
  border-radius: 10px;
  border: 1px solid ${theme.colors.GREY_50};

  &:before {
    content: '';
    padding-top: 66.6666667%;
    display: block;
  }
`

export const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
